export default __webpack_public_path__ + "static/289-4db9b60bece5667587c71081fe22af3a.gif";